import React, { useEffect, useState } from "react";
import CheckinCheckOutAttendanceTable from "./CheckinCheckOutAttendanceTable/CheckinCheckOutAttendanceTable";
import { EmptyListPage, TableLoader } from "../commons";
import { UserProfileType } from "../../redux/auth/authTypes";

type AppProps = {
  data: any;
  history: any;

  fetching: boolean;
  userProfileAllData: UserProfileType;
  handleToggleSendRegularizeApprovalData: (data: any) => void;
};
const LoggedInUsersCheckInCheckOutReport = ({
  data,
  history,
  fetching,
  userProfileAllData,
  handleToggleSendRegularizeApprovalData,
}: AppProps) => {
  const [attendanceReportData, setAttendanceReportData] = useState([]);
  useEffect(() => {
    if (data && data[0] && data[0]?.data) {
      let finalData: any = [...data[0]?.data]?.reverse();

      setAttendanceReportData(finalData);
    } else {
      setAttendanceReportData([]);
    }
  }, [data]);

  let firstName = userProfileAllData?.user_details?.basic_details?.first_name;
  let lastName = userProfileAllData?.user_details?.basic_details?.last_name;
  return (
    <div className="w-100 mt-3 boxs">
      <div>
        <div className="boxs-container-heading d-flex justify-content-between p-4">
          <span>My In and Out Time Summary</span>
          <button
            className="btn btn-outline"
            onClick={() => {
              history.push({
                pathname: `my-space/my-in-and-out-report`,
                state: {
                  userId: userProfileAllData?.user_id,
                  name: firstName + " " + lastName,
                  pic: userProfileAllData?.user_details?.profile_pic?.file_url,
                  userProfileAllData,
                },
              });
            }}
          >
            View All
          </button>
        </div>

        {fetching ? (
          <TableLoader Rows={7} ColumnPerRow={5} />
        ) : attendanceReportData?.length ? (
          <CheckinCheckOutAttendanceTable
            data={attendanceReportData}
            handleToggleSendRegularizeApprovalData={
              handleToggleSendRegularizeApprovalData
            }
          />
        ) : (
          <EmptyListPage title="No List Found!" imageWidth="30%" />
        )}
      </div>
    </div>
  );
};

export default LoggedInUsersCheckInCheckOutReport;
